import { Component, OnInit } from "@angular/core";
import { MaterialModule } from "../material.module";
import { NavHeaderComponent } from "../../shared/components/nav-header/nav-header.component";
import { HeaderService } from "../../shared/services/header.service";
import { PoliciesService } from "../policies/_services/policies.service";
import { TravelPolicyFaqPanelComponent } from "../policies/travel-policy/_components/travel-policy-faq-panel/travel-policy-faq-panel.component";
import { RouterLink, Router, RouterModule } from "@angular/router";

@Component({
    selector: "app-get-help",
    standalone: true,
    imports: [NavHeaderComponent, MaterialModule, TravelPolicyFaqPanelComponent, RouterModule],
    templateUrl: "./get-help.component.html",
    styleUrl: "./get-help.component.scss",
})

export class GetHelpComponent implements OnInit {
    address: string = '';

    constructor(
        public policiesService: PoliciesService,
        private headerService: HeaderService,
        private router: Router
    ) {}

    onBack(): void {
        this.headerService.sendExitWebViewMessage();
    }

    ngOnInit(): void {
        this.address = this.router.url;
    }
}